// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyMarquee_container__7deTL","title":"CompanyMarquee_title__aEDGZ","image":"CompanyMarquee_image__U2N8d","initialImages":"CompanyMarquee_initialImages__xWiwX"};